import { useGetV2ThemePerformance } from '@terminal/react-query-hooks/themes/useGetV2ThemePerformance';
import { useThemePerformance } from '@terminal/react-query-hooks/themes/useThemeOverview';
import { formatNumber } from '@terminal/views/dashboard/calendar-widget/calendar-event-drawer/drawer-content/utils/number-formatter';

import { Horizon } from '../ThemePerformanceSection';

export const getReturnValue = ({
  value,
  benchmarkValue,
  withBenchmark,
}: {
  value: number | undefined;
  benchmarkValue?: number;
  withBenchmark?: boolean;
}) => {
  if (withBenchmark) {
    if (benchmarkValue !== undefined && value !== undefined) {
      return value - benchmarkValue;
    } else {
      return undefined;
    }
  }

  return value;
};

export const useThemePerformanceReturn = ({
  themeId,
  selectedHorizon,
  benchmarkTags,
  numDays,
}: {
  themeId: string;
  selectedHorizon: Horizon;
  benchmarkTags?: string[];
  numDays?: number;
}) => {
  const { data, isFetching } = useGetV2ThemePerformance({
    ids: themeId,
    intraday: true,
  });
  const performanceData = data?.themes?.[0]?.performance;

  const horizonKey = selectedHorizon.toLowerCase() as keyof NonNullable<
    typeof performanceData
  >;
  const horizonReturn = performanceData?.[horizonKey];

  const { data: benchmarkData, isFetching: isBenchmarkFetching } =
    useThemePerformance(benchmarkTags, numDays);
  const benchmarkValue = benchmarkData?.aggregate?.at(-1)?.value;

  const returnValue = getReturnValue({
    value: horizonReturn,
    benchmarkValue,
    withBenchmark: !!benchmarkTags?.length,
  });

  return {
    isLoading: isFetching || isBenchmarkFetching,
    value: formatNumber({ isPercentage: true, value: returnValue }),
    isNegative: !!returnValue && returnValue < 0,
  };
};
